import Utils from '@/ecm/common/Utils'
export default class ContentTypeAutoImportConfigField {
    constructor(dto) {
        this.uuid = Utils.object.getUUID()
        this.defFieldCode = ''
        this.value = ''
        this.usesKeyword

        if (dto) {
            this.value = dto.Value
            this.defFieldCode = dto.DefFieldCode
            this.usesKeyword = dto.UsesKeyword
        }
    }

    toDto() {
        return {
            Value: this.value,
            DefFieldCode: this.defFieldCode,
            UsesKeyword: this.usesKeyword,
        }
    }
}
